import { Reducer } from 'redux';

import { NetworkTopAnnouncementsLoadAction } from '../../domains/networkTopAnnouncements/actions.types';

import { NetworkTopAnnouncementsLifecycle } from './types';

const initialState: NetworkTopAnnouncementsLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<NetworkTopAnnouncementsLifecycle, NetworkTopAnnouncementsLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'NETWORK_TOP_ANNOUNCEMENTS.LOAD_PENDING':
      return { ...initialState, pending: true };
    case 'NETWORK_TOP_ANNOUNCEMENTS.LOAD_FULFILLED':
      return { ...initialState, fulfilled: action.payload.entities.networkTopAnnouncements };
    case 'NETWORK_TOP_ANNOUNCEMENTS.LOAD_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
